<template>
  <div>
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="toQueryChargeInfo"
    >
      <div class="personal-center-page">
        <div class="personal-center-page-bg" />
        <div style="position: relative; z-index: 2">
          <div class="personal-info">
            <div class="personal-account-wrap">
              <div class="personal-account tag">{{ info.phone || "" }}</div>
            </div>
            <div class="profit-wrap">
              <div class="profit-info">
                <div class="total-revenue">
                  <div class="total-revenue-title">
                    <img
                      class="total-revenue-icon"
                      src="@/assets/img/chargingVoucher/icon-profit.png"
                    >
                    总收益（元）
                  </div>
                  <div class="total-revenue-value">
                    {{ info.incomeAmount || "0" }}元
                  </div>
                </div>
                <div class="pending-withdrawal">
                  <div class="pending-withdrawal-title">待提现</div>
                  <div class="pending-withdrawal-value">
                    {{ info.pendingWithdrawnAmount || "0" }}元
                  </div>
                </div>
              </div>
              <div class="pyramid-info">
                <div class="pyramid-info-text">
                  直接拉新：<span class="pyramid-info-number">
                    {{ info.directCount || "0" }}人
                  </span>
                </div>
                <div class="pyramid-info-text">
                  间接拉新：<span class="pyramid-info-number">
                    {{ info.indirectCount || "0" }}人
                  </span>
                </div>
              </div>
            </div>
            <div
              class="score-wrap"
              v-if="info.totalScore"
            >
              <div class="total-score">
                <div class="total-score-title">
                  <img
                    class="total-score-icon"
                    src="@/assets/img/chargingVoucher/icon-score.png"
                  >
                  累计积分
                </div>
                <div class="total-score-value">
                  {{ info.totalScore || "0" }}分
                </div>
              </div>
              <div class="pending-use-score">
                <div class="pending-use-score-title">剩余可使用积分</div>
                <div class="pending-use-score-value">
                  {{ info.availableScore || "0" }}分
                </div>
              </div>
            </div>
          </div>
          <div class="opera-functional-area">
            <div
              class="opera-column arrow"
              v-for="item in customeOperaBtnOptions"
              :key="item.title"
              @click="() => item.onClick()"
            >
              <img
                v-if="item.icon"
                class="opera-column-icon"
                :src="item.icon"
              >
              <span class="opera-column-title">{{ item.title }}</span>
              <span class="opera-column-sub-title">{{
                item.subTitle || ""
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import IconMyOrder from '@/assets/img/chargingVoucher/icon-my-order.png';
import IconMyShareCode from '@/assets/img/chargingVoucher/icon-my-share-code.png';
import IconMyEarnings from '@/assets/img/chargingVoucher/icon-my-earnings.png';
import IconMyRecruitment from '@/assets/img/chargingVoucher/icon-my-recruitment.png';
import IconMyScore from '@/assets/img/chargingVoucher/icon-my-score.png';
import IconMyWithdrawal from '@/assets/img/chargingVoucher/icon-my-withdrawal.png';
import IconMyInvoice from '@/assets/img/chargingVoucher/icon-my-invoice.png';
import { queryChargeInfo } from '@/common/api.js';

class CreateInfo {
  phone = ''; // 用户手机号
  incomeAmount = ''; // 总收益(元)
  pendingWithdrawnAmount = ''; // 待提现金额(元)
  directCount = ''; // 直接拉新人数
  indirectCount = ''; // 间接拉新人数
}

export default {
  name: 'PersonalCenter',
  data() {
    return {
      profitOptions: [
        {
          title: '直接拉新',
          value: '0.00'
        },
        {
          title: '间接拉新',
          value: '0.00'
        },
        {
          title: '总收益（元）',
          value: '0.00'
        },
        {
          title: '待提现（元）',
          value: '0.00'
        }
      ],
      operaBtnOptions: [
        {
          title: '我的订单',
          icon: IconMyOrder,
          onClick: () => {
            this.$router.push({
              name: 'ChargingVoucherMyOrder'
            });
          }
        },
        // {
        //   title: '我的分享码',
        //   icon: IconMyShareCode,
        //   onClick: () => {
        //     this.$router.push({
        //       name: 'ChargingVoucherShareCode'
        //     });
        //   }
        // },
        {
          title: '我的钱包',
          icon: IconMyEarnings,
          onClick: () => {
            this.$router.push({
              name: 'ChargingVoucherMyEarnings'
            });
          }
        },
        {
          title: '我的拉新',
          icon: IconMyRecruitment,
          onClick: () => {
            this.$router.push({
              name: 'ChargingVoucherMyRecruitment'
            });
          }
        },
        {
          title: '我的积分',
          icon: IconMyScore,
          onClick: () => {
            this.$router.push({
              name: 'ChargingVoucherMyScore'
            });
          }
        },
        {
          title: '我的提现',
          subTitle: '（预计8月底开放，敬请期待）',
          icon: IconMyWithdrawal,
          onClick: () => {
            this.$toast('预计8月底开放，敬请期待');
            console.log('我的提现');
          }
        },
        {
          title: '我的发票',
          subTitle: '（预计9月底开放，敬请期待）',
          icon: IconMyInvoice,
          onClick: () => {
            this.$toast('预计9月底开放，敬请期待');
            console.log('我的发票');
          }
        }
      ],
      info: new CreateInfo(),
      showPullRefreshLoading: true
    };
  },
  created() {
    this.toQueryChargeInfo();
  },
  computed: {
    customeOperaBtnOptions() {
      let tempOperaBtnOptions = this.operaBtnOptions;
      if (!this.info.totalScore) {
        tempOperaBtnOptions = tempOperaBtnOptions.filter(
          (item) => item.title !== '我的积分'
        );
      }
      return tempOperaBtnOptions || [];
    }
  },
  methods: {
    toQueryChargeInfo() {
      const param = {};
      this.showPullRefreshLoading = true;
      queryChargeInfo(param)
        .then((res) => {
          if (res) {
            this.info = res;
          }
        })
        .finally(() => {
          this.showPullRefreshLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.personal-center-page {
  box-sizing: border-box;
  min-height: calc(100vh - 98px);
  padding: 32px;

  .personal-center-page-bg {
    height: 360px;
    width: 100vw;
    background-image: linear-gradient(180deg, #FFB6AE 22%, #F7F7F7 100%);
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .personal-info {
    margin-top: 57px;
    margin-bottom: 16px;

    .personal-account-wrap {
      display: flex;
      align-items: center;

      .personal-account {
        font-size: 36px;
        color: #224669;
        font-weight: bold;
        display: flex;
        align-items: center;
        line-height: 50px;
        min-height: 50px;
        margin-bottom: 24px;

        &.tag::after {
          content: "账号";
          background: #afc6dd;
          border-radius: 6px;
          padding: 2px 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #ffffff;
          font-weight: 400;
          margin-left: 16px;
          height: 32px;
          box-sizing: border-box;
        }
      }
    }
    .profit-wrap {
      box-sizing: border-box;
      padding: 24px 32px;
      width: 100%;
      background: #ffffff;
      border-radius: 20px;
      height: 265px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 16px;

      .profit-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 32px;
        border-bottom: 1px solid #d8d8d8;

        .total-revenue {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .total-revenue-icon {
            width: 32px;
            height: 32px;
            object-fit: contain;
            margin-right: 16px;
          }
          .total-revenue-title {
            font-size: 28px;
            color: #383838;
            letter-spacing: 0.42px;
            font-weight: 400;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            line-height: 40px;
            min-height: 40px;
          }
          .total-revenue-value {
            font-size: 40px;
            color: #ff722c;
            font-weight: bold;
            line-height: 56px;
            min-height: 56px;
          }
        }
        .pending-withdrawal {
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          .pending-withdrawal-title {
            font-size: 28px;
            color: #787878;
            letter-spacing: 0.42px;
            font-weight: 400;
            margin-bottom: 16px;
            line-height: 40px;
            min-height: 40px;
          }
          .pending-withdrawal-value {
            font-size: 40px;
            color: #225e99;
            font-weight: bold;
            line-height: 56px;
            min-height: 56px;
          }
        }
      }
      .pyramid-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .pyramid-info-text {
          font-size: 32px;
          color: #383838;
          letter-spacing: 0.48px;
          font-weight: 400;
          line-height: 45px;
        }
        .pyramid-info-number {
          font-size: 32px;
          color: #225e99;
          font-weight: bold;
        }
      }
    }
    .score-wrap {
      box-sizing: border-box;
      padding: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      border-radius: 20px;

      .total-score {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .total-score-title {
          font-size: 28px;
          color: #383838;
          letter-spacing: 0.42px;
          font-weight: 400;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          line-height: 40px;
          min-height: 40px;

          .total-score-icon {
            width: 32px;
            height: 32px;
            object-fit: contain;
            margin-right: 16px;
          }
        }
        .total-score-value {
          font-size: 40px;
          color: #fe7256;
          font-weight: bold;
          line-height: 56px;
          min-height: 56px;
        }
      }
      .pending-use-score {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .pending-use-score-title {
          font-size: 28px;
          color: #383838;
          letter-spacing: 0.42px;
          text-align: right;
          font-weight: 400;
          margin-bottom: 16px;
          line-height: 40px;
          min-height: 40px;
        }
        .pending-use-score-value {
          font-size: 40px;
          color: #225e99;
          text-align: right;
          font-weight: bold;
          line-height: 56px;
          min-height: 56px;
        }
      }
    }
  }
  .opera-functional-area {
    box-sizing: border-box;
    width: 100%;
    background: #ffffff;
    border-radius: 20px;
    padding: 0px 32px;

    .opera-column {
      height: 120px;
      display: flex;
      align-items: center;
      background-color: #ffffff;
      border-bottom: 1px solid rgba(216, 216, 216, 1);
      position: relative;

      .opera-column-icon {
        width: 42px;
        height: 42px;
        object-fit: contain;
        margin-right: 32px;
      }
      .opera-column-title {
        font-size: 32px;
        color: #383838;
        font-weight: 400;
      }
      .opera-column-sub-title {
        font-size: 24px;
        color: #c8c8c8;
        font-weight: 400;
      }
      &:last-child {
        border-bottom: unset;
      }
      &.arrow::after {
        content: "";
        width: 12px;
        height: 12px;
        border-right: 1px solid #c8c8c8;
        border-bottom: 1px solid #c8c8c8;
        color: #c8c8c8;
        position: absolute;
        right: 9px;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
